export default {
  data () {
    return {
      $_serverError: null
    }
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_setServerError (val = null) {
      this.$data.$_serverError = val
    }
  }
}
